import { Skeleton, Stack, Typography, useMediaQuery } from '@mui/material';
import { castArray } from 'lodash-es';
import theme from 'providers/theme/theme';
import type { FC } from 'react';
import {
  QuoteDetailsCardCostDetailsStyle,
  QuoteDetailsCardNoteStyle,
} from '../../QuoteDetailsCard.styles';
import { QuoteCostDetailsFullStyle, QuoteCostDetailsStyle } from './QuoteCostDetails.styles';

interface QuoteCostDetailsProps {
  monthlyPayment: string;
  totalPayment: string;
  discountedTotalDue: string;
  isAnnualPaymentPlan: boolean;
  priceLoading?: boolean;
}

const QuoteCostDetails: FC<QuoteCostDetailsProps> = ({
  monthlyPayment,
  totalPayment,
  discountedTotalDue,
  isAnnualPaymentPlan,
  priceLoading = true,
}) => {
  const isTabletLayout = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Stack sx={QuoteCostDetailsStyle}>
      <Stack
        sx={QuoteDetailsCardCostDetailsStyle}
        data-test={priceLoading ? 'estimated-premium-placeholder' : 'estimated-premium-calculated'}
      >
        {!priceLoading ? (
          isAnnualPaymentPlan ? (
            <>
              <Typography component="span" variant="price">
                {discountedTotalDue}
              </Typography>
              <Typography component="span">annually</Typography>
            </>
          ) : (
            <>
              <Typography component="span" variant="price">
                {monthlyPayment}
              </Typography>
              <Typography component="span">per month</Typography>
            </>
          )
        ) : (
          <Skeleton height="43px" width="260px" />
        )}
      </Stack>

      {!isAnnualPaymentPlan &&
        (!priceLoading ? (
          <Typography sx={QuoteCostDetailsFullStyle}>
            <strong>{totalPayment}</strong> over 12 months
          </Typography>
        ) : (
          <Skeleton height="23px" width="200px" />
        ))}

      <Typography
        variant="h3"
        // added this font-size condition to fit the design
        sx={[...castArray(isTabletLayout && { fontSize: '12px' }), QuoteDetailsCardNoteStyle]}
      >
        {!isAnnualPaymentPlan ? 'Only one month due at purchase' : 'Full payment due at purchase'}
      </Typography>
    </Stack>
  );
};

export default QuoteCostDetails;
